import { AxiosResponse } from 'axios';
import { API } from '../../utils/axios';
import { APIResponseStatus } from '../types';
import {
  ClientSecretResponse,
  PaymentHistoryResponse,
  PaymentMethodsResponse,
} from '../../features/settings/types';

class PaymentService {
  static getPaymentMethods(patientID: string) {
    return API.get<any, AxiosResponse<APIResponseStatus<PaymentMethodsResponse[]>>>(
      `/v1/resources/Payment/PaymentMethod/${patientID}`,
    ).then((res) => res.data);
  }

  static getPaymentsHistory(patientID: string, limit: number, offset: number) {
    return API.post<any, AxiosResponse<APIResponseStatus<PaymentHistoryResponse[]>>>(
      `/v1/resources/Payment/History/${patientID}`,
      { limit: limit, offset: offset },
    ).then((res) => res.data);
  }

  static setPaymentMethodDefault(patientID: string, paymentMethodId: string) {
    return API.put<any, AxiosResponse<APIResponseStatus>>(
      `/v1/resources/Payment/DefaultCard/${patientID}/${paymentMethodId}`,
    ).then((res) => res.data);
  }

  static getClientSecret(patientID: string) {
    return API.put<any, AxiosResponse<APIResponseStatus<ClientSecretResponse>>>(
      `/v1/resources/Payment/add-card/${patientID}`,
    ).then((res) => res.data);
  }

  static removePaymentMethod(patientID: string, paymentMethodId: string) {
    return API.delete<any, AxiosResponse<APIResponseStatus>>(
      `v1/resources/Payment/DetachPaymentMethod/${patientID}/${paymentMethodId}`,
    ).then((res) => res.data);
  }
}

export default PaymentService;
